const scientificFormatter = new Intl.NumberFormat('en-US', {
  minimumSignificantDigits: 3,
  maximumSignificantDigits: 3,
  useGrouping: false,
});

export function formatScientificValue(value) {
  if (value === null || value === undefined || !Number.isFinite(Number(value))) {
    return '—';
  }

  const numericValue = Number(value);
  if (numericValue === 0) {
    return '0';
  }

  const magnitude = Math.abs(numericValue);
  if (magnitude < 0.001 || magnitude >= 1_000_000) {
    return numericValue.toExponential(2);
  }

  return scientificFormatter.format(numericValue);
}

export function formatDetectionPct(value) {
  if (value === null || value === undefined || !Number.isFinite(Number(value))) {
    return '—';
  }
  return `${Number(value).toFixed(1)}%`;
}

export function formatEndothelialContextFraction(value) {
  if (value === null || value === undefined || !Number.isFinite(Number(value))) {
    return 'N/A';
  }
  return formatScientificValue(value);
}

export function formatAppearance(value, scope) {
  if (value === null || value === undefined || !Number.isFinite(Number(value))) {
    return '—';
  }
  return `${Number(value)}/${scope === 'subset' ? 7 : 15}`;
}
